"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentUrl = paymentUrl;
function paymentUrl(payment) {
    return `https://dashboard.stripe.com/payments/${payment.id}`;
}
//# sourceMappingURL=payments.js.map